// extracted by mini-css-extract-plugin
export default {"fullHeight":"DefaultCard_fullHeight__lwb0Y"};